import {
  Conversation,
  ConversationsResponse as Response,
  convertConversation,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { addConversationToCacheIfNeeded } from './shared/utils'

export function useCreateDirectConversation() {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()

  return useMutation({
    mutationFn: findOrCreateDirectConversation,
    onSuccess: async directConversation => {
      await addConversationToCacheIfNeeded(client, directConversation)
      sendWebsocketMessage({
        action: 'conversationEvent',
        conversationEvent: directConversation,
      })
    },
  })

  async function findOrCreateDirectConversation(
    recipientId: string
  ): Promise<Conversation> {
    return convertConversation(
      await server.post<Response.Conversation>(
        `/v2/chat/conversations/direct`,
        {
          recipient_id: recipientId,
        }
      )
    )
  }
}
